<div *ngIf="usuarioAutenticado">
  <nav class="navbar navbar-expand-md col-12 d-flex justify-content-center position-fixed py-1">
    <div class="container-fluid gap-2 justify-content-start ">
      <button class="navbar-toggler d-flex" type="button" (click)="collapseMenu()">
        <span class="navbar-toggler-icon"></span>
      </button>
    </div>
    <div >
      <div>
        
        <div class="d-flex justify-content-end gap-2">
          <span *ngIf="ambiente.length > 0" class="d-flex justify-content-end text-secondary flex-none">{{ambiente}} |</span>
          <!--<i id="sino" class="fa-solid fa-bell text-primary mt-1 alert"></i>-->Usuário - {{usuarioLogado.usuario}} 
        </div>
        <div class="d-flex justify-content-end gap-2">
          <!-- <div class="marquee-container">
            <span id="marquee_alert" class="marquee d-flex justify-content-end text-secondary flex-none text-danger marquee_animation">{{param_alert}}</span>
          </div> -->
          <app-param-alert></app-param-alert>
          
          <button data-bs-toggle="modal" data-bs-target="#modalEmpresa" [disabled]="empresaCount" class="btn-link text-primary bg-transparent flex-none border-0">
            {{usuarioLogado.cod_empresa}} - 
            {{usuarioLogado.empresa_nome | uppercase}}
          </button>
        </div>
      </div>
    </div>
    
    <div class="mx-2 dropdown">
      <a href="#" class="d-flex align-items-center text-dark text-decoration-none dropdown-toggle gap-2" id="dropdownUser1" data-bs-toggle="dropdown" aria-expanded="false">
        <p class="m-0">{{usuarioLogado.login | uppercase}}</p>
        <img src="./assets/img/img-user.png" alt="xml" width="40" height="40" class="rounded-circle">
      </a>
      <ul class="dropdown-menu dropdown-menu-end dropdown-menu dropdown-menu-end-end dropdown-menu dropdown-menu-end-dark text-small shadow" aria-labelledby="dropdownUser1">
        <li>
          <a class="dropdown-item" data-bs-toggle="modal" data-bs-target="#modalPerfil" (click)="modalPerfil()">Perfil</a>
        </li>
        <li>
          <a class="dropdown-item" data-bs-toggle="modal" data-bs-target="#modalConfig" (click)="carregaChkConfig()">Configurações</a>
        </li>
        <li>
          <a class="dropdown-item" data-bs-toggle="modal" data-bs-target="#modalLicencas" (click)="openLicenseControl()">Controle de Licenças</a>
        </li>
        <li>
          <hr class="dropdown-divider">
        </li>
        <li>
          <a class="dropdown-item" (click)="logout()">Logout</a>
        </li>
      </ul>
    </div>
  </nav>
</div>

<!-- modal controle de licenças -->
<div class="modal fade" id="modalLicencas" data-bs-backdrop="static" data-bs-keyboard="true" tabindex="-1" aria-labelledby="modalLicencasLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h1 class="modal-title fs-5" id="modalLicencasLabel">Controle de Licenças</h1>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <div class="alert alert-secondary" *ngIf="carregandoLicenca">
          Consultando licenças...
        </div>

        <div *ngIf="!carregandoLicenca" class="alert" [ngClass]="licenseStatusData.pode_incluir || licenseStatusData.ilimitada ? 'alert-success' : 'alert-danger'">
          <div><strong>Situação:</strong> {{ licenseStatusData.situacao || 'N/A' }}</div>
          <div class="mt-2">{{ getLicenseResumo() }}</div>
          <div class="mt-2" *ngIf="licenseStatusData.mensagem">{{ licenseStatusData.mensagem }}</div>
        </div>

        <div *ngIf="!carregandoLicenca" class="d-flex flex-column gap-2">
          <div><strong>Total licenciado:</strong> {{ licenseStatusData.licencas }}</div>
          <div><strong>Total utilizado:</strong> {{ licenseStatusData.utilizadas }}</div>
          <div><strong>Total disponível:</strong> {{ licenseStatusData.disponiveis }}</div>
          <div><strong>Licença ilimitada:</strong> {{ licenseStatusData.ilimitada ? 'Sim' : 'Não' }}</div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- modal altera dados Do Perfil -->
<div class="modal fade" id="modalPerfil" data-bs-backdrop="static" data-bs-keyboard="true" tabindex="-1" aria-labelledby="modalPerfilLabel" aria-hidden="true">
  <form #perfilForm="ngForm">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h1 class="modal-title fs-5" id="modalPerfilLabel">Configurações de Perfil</h1>
          <button id="close-modalPerfil" type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="limpaForm()"></button>
        </div>
        <div class="modal-body">
          <div class="d-flex gap-2">
            <div class="w-50">
              <label for="login_perfil">Login perfil:</label>
              <input name="login_perfil" disabled id="login_perfil" #name="ngModel" type="text" class="form-control" aria-describedby="basic-addon1" [(ngModel)]="usuarioLogado.usuario">
            </div>
            <div class="align-self-end">
              <div class="form-check form-switch gap-2 d-flex justify-content-center mt-1">
                <input class="form-check-input" style="width: 3.3rem; height: 2rem;" type="checkbox" role="switch" id="ativarAutenticacaoSwitch" (change)="autenticacaoDoisFatores()">
                <label class="align-self-center" for="ativarAutenticacaoSwitch">Autenticação de dois fatores</label>
              </div>
            </div>
          </div>
  
          <label for="senha_atual">Senha atual:</label>
          <div class="form-outline mb-4 input-group">
            <input name="senha_atual" id="senha_atual" type="password"  class="form-control border-end-0" aria-describedby="basic-addon1" [(ngModel)]="atualizaUsuario.senhaAtual" required>
            <div class="input-group-text bg-transparent border-start-0 cursor-ptr">
              <span [hidden]="visualizaSenha" (click)="visualizarSenha('senha_atual')">
                <i  class="fa-regular fa-eye text-secondary "></i>
              </span>
              <span [hidden]="!visualizaSenha" (click)="visualizarSenha('senha_atual')">
                <i class="fa-regular fa-eye-slash text-secondary"></i>
              </span>
            </div>
          </div>
  
          <label for="nova_senha">Nova senha:</label>
          <div class="form-outline mb-4 input-group">
            <input name="nova_senha" id="nova_senha" #name="ngModel" type="password" class="form-control border-end-0" aria-describedby="basic-addon1" [(ngModel)]="atualizaUsuario.novaSenha" (keyup)="verificaSenha()" required>
            <div class="input-group-text bg-transparent border-start-0 rounded-end cursor-ptr">
              <span [hidden]="visualizaNovaSenha" (click)="visualizarSenha('nova_senha')">
                <i  class="fa-regular fa-eye text-secondary "></i>
              </span>
              <span [hidden]="!visualizaNovaSenha" (click)="visualizarSenha('nova_senha')">
                <i class="fa-regular fa-eye-slash text-secondary"></i>
              </span>
            </div>
            <button class="btn text-primary" data-bs-toggle="modal" data-bs-target="#infoSenhaModal"><i class="fa-solid fa-question"></i></button>
          </div>

          <div [hidden]="AlertSenha.showAlert" class="alert alert-danger ws-pw" role="alert">{{AlertSenha.senha}}</div>

          <label for="confirm_senha">Confirmar nova senha:</label>
          <div class="form-outline mb-4 input-group">
            <input name="confirm_senha" id="confirm_senha" type="password" class="form-control border-end-0" aria-describedby="basic-addon1"  [(ngModel)]="atualizaUsuario.confirmaSenha" required>
            <div class="input-group-text bg-transparent border-start-0 rounded-end cursor-ptr">
              <span [hidden]="visualizaSenhaConfirm" (click)="visualizarSenha('confirm_senha')">
                <i  class="fa-regular fa-eye text-secondary "></i>
              </span>
              <span [hidden]="!visualizaSenhaConfirm" (click)="visualizarSenha('confirm_senha')">
                <i class="fa-regular fa-eye-slash text-secondary"></i>
              </span>
            </div>
          </div>
          <div [hidden]="atualizaUsuario.novaSenha == atualizaUsuario.confirmaSenha" class="alert alert-danger" role="alert">
            As senhas informadas não coicidem.
          </div>
  
          <label for="dica_senha">Dica da senha:</label>
          <input name="dica_senha" id="dica_senha" #name="ngModel" type="text" class="form-control" aria-describedby="basic-addon1"[(ngModel)]="atualizaUsuario.dicaSenha" required>
        </div>
        <div class="modal-footer">
          <!-- <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="limpaForm()">Fechar</button> -->
          <button type="button" class="btn btn-primary" type="submit"[disabled]="!perfilForm.form.valid || !AlertSenha.showAlert || atualizaUsuario.novaSenha != atualizaUsuario.confirmaSenha" (click)="atualizarPerfil()">Alterar</button>
        </div>
      </div>
    </div>
  </form>
</div>

<!-- modal informações sobre a senha -->
<div class="modal fade" id="infoSenhaModal" data-bs-backdrop="static" data-bs-keyboard="true" tabindex="-1" aria-labelledby="infoSenhaModalLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h1 class="modal-title fs-5" id="infoSenhaModalLabel">Ajuda no Cadastro de Usuários</h1>
        <button type="button" class="btn-close" data-bs-dismiss="modal"  data-bs-toggle="modal" data-bs-target="#modalPerfil" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <h4>Cadastro de Usuarios: Campo Senha</h4>
        <hr>
        <strong>
          Para uma senha com nível de segurança forte, utilize uma senha que contenha:
        </strong>  
        <ul>
          <li>6 ou mais caractéres</li>
          <li>Letras maiúsculas</li>
          <li>Letras minúsculas</li>
          <li>1 ou mais números</li>
          <li>2 ou mais caractéres especiais</li>
        </ul>
        <strong>
          É importante evitar senhas com números sequenciais, letras sequenciais ou datas comemorativas, pois isso contribui para que sua senha possa ser descoberta sem muito esforço.
        </strong>
      </div>
      <div class="modal-footer">
        <!-- <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" data-bs-toggle="modal" data-bs-target="#modalPerfil">Fechar</button> -->
      </div>
    </div>
  </div>
</div>

<!-- modal troca empresa -->
<div class="modal fade" id="modalEmpresa" data-bs-backdrop="static" data-bs-keyboard="true" tabindex="-1" aria-labelledby="modalEmpresaLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h1 class="modal-title fs-5" id="modalEmpresaLabel">Trocar Empresa</h1>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="trocaEmpresa = ''"></button>
      </div>
      <div class="modal-body">
        <label for="troca_empresa" class="form-label">Selecione Empresa:</label>
        <select name="troca_empresa" id="troca_empresa" class="form-control" [(ngModel)]="trocaEmpresa">
          <option disabled value="">Selecione uma Empresa</option>
          <option *ngFor="let Empresa of usuarioLogado.empresas" [value]="Empresa.id_nfer_empresa">{{Empresa.den_empresa}} - {{Empresa.cod_empresa}}</option>
        </select>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary"  data-bs-dismiss="modal" (click)="trocarEmpresa()">Trocar</button>
      </div>
    </div>
  </div>
</div>

<button hidden id="modalQRcode_button" data-bs-toggle="modal" data-bs-target="#modalQRcode"></button>
<button hidden id="modalCancelaAutenticador_button" data-bs-toggle="modal" data-bs-target="#modalCancelaAutenticador"></button>

<!-- modal Autenticador -->
<div class="modal fade" id="modalQRcode" (keydown.escape)="limpaModalsAuth(1)" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="modalQRcodeLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h1 class="modal-title fs-5" id="modalQRcodeLabel">Escaneie o QRcode ou digite o codigo!</h1>
        <button id="close_modal_autenticator" type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="limpaModalsAuth(1)"></button>
      </div> 
      <div class="modal-body d-flex flex-column gap-2">
        <div class="d-flex justify-content-center flex-column" style=" scale: 0.9;">
          <img [src]="AuthKey.qrcode">
          <h4 class="text-center">{{AuthKey.key}}</h4>
        </div>
        <div class="d-flex justify-content-center input-group">
          <input class="form-control border-end-0 w-50" type="text" placeholder="digite o código" [(ngModel)]="codeOTP">
          <button class="btn btn-primary border-start-0" (click)="testCodeOTP();alertAuth = true">Confirmar MFA</button>
        </div>
        <div *ngIf="alertAuth" class="alert alert-success" role="alert" [hidden]="!autorizado">
          Código validado com sucesso, já pode fechar esse popup!
        </div>
        <div *ngIf="alertAuth" class="alert alert-danger" role="alert" [hidden]="autorizado">
          Código inválido, por favor digite novamente!
        </div>
        <div class="alert alert-secondary" role="alert" >
          Ceritfique-se de adicionar o código ao seu aplicativo Google Authenticator,
           após o fechamento dessa aba o qrcode não poderá mais ser acessado.
        </div>
      </div>
    </div>
  </div>
</div>

<!-- modal cancela autenticador -->
<div class="modal fade" (keydown.escape)="limpaModalsAuth(2)" id="modalCancelaAutenticador" data-bs-backdrop="static" data-bs-keyboard="true" tabindex="-1" aria-labelledby="modalCancelaAutenticadorLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h1 class="modal-title fs-5" id="modalCancelaAutenticadorLabel">Escaneie o QRcode ou digite o codigo!</h1>
        <button id="close_cancela_autenticator" type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="limpaModalsAuth(2)"></button>
      </div> 
      <div class="modal-body d-flex flex-column gap-2">
        <div class="d-flex justify-content-center input-group">
          <input class="form-control border-end-0 w-50" type="text" placeholder="digite o código" [(ngModel)]="codeOTP">
          <button class="btn btn-primary border-start-0" (click)="cancelaAutenticador();alertAuth = true">Confirmar MFA</button>
        </div>
        <div *ngIf="alertAuth" class="alert alert-success" role="alert" [hidden]="!autorizado">
          Código validado com sucesso, já pode fechar esse popup!
        </div>
        <div *ngIf="alertAuth" class="alert alert-danger" role="alert" [hidden]="autorizado">
          Código inválido, por favor digite novamente!
        </div>
        <div class="alert alert-secondary" role="alert" >
          Ceritfique-se de adicionar o código ao seu aplicativo Google Authenticator,
           após o fechamento dessa aba o qrcode não poderá mais ser acessado.
        </div>
      </div>
    </div>
  </div>
</div>

<!-- modal configuraçõs -->
<div class="modal fade" id="modalConfig" data-bs-backdrop="static" data-bs-keyboard="true" tabindex="-1" aria-labelledby="modalConfigLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h1 class="modal-title fs-5" id="modalConfigLabel">Configurações do Usuário</h1>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <fieldset>
          <legend>Administrador do Sistema</legend>
          <hr>
          <div>
            <div id="ordenar_pendencias_chk" class="row g-2" role="group" aria-label="Basic checkbox toggle button group">
              <div class="d-flex align-middle justify-content-between">
                <div class="w-50 fs-6 align-self-center">Ordenar Pendências:</div>
                <input type="checkbox" class="btn-check" id="ord_pend_padrao" autocomplete="off" [(ngModel)]="chkOrdenaPendencias.padrao" (click)="selecionaOrdenacaoPendencia('padrao')">
                <label class="btn-chk btn-outline-secondary d-flex justify-content-between gap-2 w-50" for="ord_pend_padrao">
                  <div>Padrão</div>
                  <div>
                    <span [hidden]="!chkOrdenaPendencias.padrao"><i class="fa-solid fa-circle-check"></i></span>
                    <span [hidden]="chkOrdenaPendencias.padrao"><i class="fa-regular fa-circle"></i></span>
                  </div>
                </label>
              </div>
              <div class="d-flex w-50 flex-column align-middle position-relative">
                <input type="checkbox" class="btn-check" id="ord_pend_nf" autocomplete="off" [(ngModel)]="chkOrdenaPendencias.nf" (click)="selecionaOrdenacaoPendencia('nf')">
                <label class="btn-chk btn-outline-secondary d-flex justify-content-between gap-2 rounded-0 rounded-top" for="ord_pend_nf">
                  <div>NF</div>
                  <div>
                    <span [hidden]="!chkOrdenaPendencias.nf"><i class="fa-solid fa-circle-check"></i></span>
                    <span [hidden]="chkOrdenaPendencias.nf"><i class="fa-regular fa-circle"></i></span>
                 </div>
                </label>
              
                <input type="checkbox" class="btn-check" id="ord_pend_sts" autocomplete="off" [(ngModel)]="chkOrdenaPendencias.sts" (click)="selecionaOrdenacaoPendencia('sts')">
                <label class="btn-chk btn-outline-secondary d-flex justify-content-between gap-2 border-top-0 rounded-0" for="ord_pend_sts">
                  <div>Status</div>
                  <div>
                    <span [hidden]="!chkOrdenaPendencias.sts"><i class="fa-solid fa-circle-check"></i></span>
                    <span [hidden]="chkOrdenaPendencias.sts"><i class="fa-regular fa-circle"></i></span>
                 </div>
                </label>
              
                <input type="checkbox" class="btn-check" id="ord_pend_dt_emss" autocomplete="off" [(ngModel)]="chkOrdenaPendencias.dt_emss" (click)="selecionaOrdenacaoPendencia('dt_emss')">
                <label class="btn-chk btn-outline-secondary d-flex justify-content-between gap-2 border-top-0 rounded-0" for="ord_pend_dt_emss">
                  <div>Data Emissão</div>
                  <div>
                    <span [hidden]="!chkOrdenaPendencias.dt_emss"><i class="fa-solid fa-circle-check"></i></span>
                    <span [hidden]="chkOrdenaPendencias.dt_emss"><i class="fa-regular fa-circle"></i></span>
                 </div>
                </label>

                <input type="checkbox" class="btn-check" id="ord_pend_forn" autocomplete="off" [(ngModel)]="chkOrdenaPendencias.forn" (click)="selecionaOrdenacaoPendencia('forn')">
                <label class="btn-chk btn-outline-secondary d-flex justify-content-between gap-2 border-top-0 rounded-0 rounded-bottom" for="ord_pend_forn">
                  <div>Fornecedor</div>
                  <div>
                    <span [hidden]="!chkOrdenaPendencias.forn"><i class="fa-solid fa-circle-check"></i></span>
                    <span [hidden]="chkOrdenaPendencias.forn"><i class="fa-regular fa-circle"></i></span>
                 </div>
                </label>
              </div>
              
              <div class="d-flex w-50 flex-column align-middle position-relative">
                <input type="checkbox" class="btn-check" id="ord_pend_nf_dec" autocomplete="off" [(ngModel)]="chkOrdenaPendencias.nf_dec" (click)="selecionaOrdenacaoPendencia('nf_dec')">
                <label class="btn-chk btn-outline-secondary d-flex justify-content-between gap-2 rounded-0 rounded-top" for="ord_pend_nf_dec">
                  <div>NF decrescente</div>
                  <div>
                    <span [hidden]="!chkOrdenaPendencias.nf_dec"><i class="fa-solid fa-circle-check"></i></span>
                    <span [hidden]="chkOrdenaPendencias.nf_dec"><i class="fa-regular fa-circle"></i></span>
                 </div>
                </label>
              
                <input type="checkbox" class="btn-check" id="ord_pend_sts_dec" autocomplete="off" [(ngModel)]="chkOrdenaPendencias.sts_dec" (click)="selecionaOrdenacaoPendencia('sts_dec')">
                <label class="btn-chk btn-outline-secondary d-flex justify-content-between gap-2 border-top-0 rounded-0" for="ord_pend_sts_dec">
                  <div>Status decrescente</div>
                  <div>
                    <span [hidden]="!chkOrdenaPendencias.sts_dec"><i class="fa-solid fa-circle-check"></i></span>
                    <span [hidden]="chkOrdenaPendencias.sts_dec"><i class="fa-regular fa-circle"></i></span>
                 </div>
                </label>
              
                <input type="checkbox" class="btn-check" id="ord_pend_dt_emss_dec" autocomplete="off" [(ngModel)]="chkOrdenaPendencias.dt_emss_dec" (click)="selecionaOrdenacaoPendencia('dt_emss_dec')">
                <label class="btn-chk btn-outline-secondary d-flex justify-content-between gap-2 border-top-0 rounded-0" for="ord_pend_dt_emss_dec">
                  <div>Data Emissão decrescente</div>
                  <div>
                    <span [hidden]="!chkOrdenaPendencias.dt_emss_dec"><i class="fa-solid fa-circle-check"></i></span>
                    <span [hidden]="chkOrdenaPendencias.dt_emss_dec"><i class="fa-regular fa-circle"></i></span>
                 </div>
                </label>

                <input type="checkbox" class="btn-check" id="ord_pend_forn_dec" autocomplete="off" [(ngModel)]="chkOrdenaPendencias.forn_dec" (click)="selecionaOrdenacaoPendencia('forn_dec')">
                <label class="btn-chk btn-outline-secondary d-flex justify-content-between gap-2 border-top-0 rounded-0 rounded-bottom" for="ord_pend_forn_dec">
                  <div>Fornecedor decrescente</div>
                  <div>
                    <span [hidden]="!chkOrdenaPendencias.forn_dec"><i class="fa-solid fa-circle-check"></i></span>
                    <span [hidden]="chkOrdenaPendencias.forn_dec"><i class="fa-regular fa-circle"></i></span>
                 </div>
                </label>
              </div>
            </div>
            <hr>
            <h6>Aba Padão:</h6>
            <div id="aba_padrao_chk" class="row g-2">
              <div class="d-flex w-50 flex-column align-middle position-relative" role="group" aria-label="Basic checkbox toggle button group">
                <input type="checkbox" class="btn-check" id="aba_pad_pend_nfe" autocomplete="off" [(ngModel)]="chkAbaPadrao.pend_nfe" (click)="selecionaAbaPadrao('pend_nfe')">
                <label class="btn-chk btn-outline-secondary d-flex justify-content-between rounded-0 rounded-top" for="aba_pad_pend_nfe">
                  <div>Pendências NF-e</div>
                  <div>
                    <span [hidden]="!chkAbaPadrao.pend_nfe"><i class="fa-solid fa-circle-check"></i></span>
                    <span [hidden]="chkAbaPadrao.pend_nfe"><i class="fa-regular fa-circle"></i></span>
                 </div>
                </label>
              
                <input type="checkbox" class="btn-check" id="aba_pad_pend_tms" autocomplete="off" [(ngModel)]="chkAbaPadrao.pend_tms" (click)="selecionaAbaPadrao('pend_tms')">
                <label class="btn-chk btn-outline-secondary d-flex justify-content-between border-top-0 rounded-0 rounded-bottom" for="aba_pad_pend_tms">
                  <div>Pendências TMS</div>
                  <div>
                    <span [hidden]="!chkAbaPadrao.pend_tms"><i class="fa-solid fa-circle-check"></i></span>
                    <span [hidden]="chkAbaPadrao.pend_tms"><i class="fa-regular fa-circle"></i></span>
                 </div>
                </label>
              </div>
              
              <div class="d-flex w-50 flex-column align-middle position-relative" role="group" aria-label="Basic checkbox toggle button group">
                <input type="checkbox" class="btn-check" id="aba_pad_pend_cte" autocomplete="off" [(ngModel)]="chkAbaPadrao.pend_cte" (click)="selecionaAbaPadrao('pend_cte')">
                <label class="btn-chk btn-outline-secondary d-flex justify-content-between rounded-0 rounded-top" for="aba_pad_pend_cte">
                  <div>Pendências CT-e</div>
                  <div>
                    <span [hidden]="!chkAbaPadrao.pend_cte"><i class="fa-solid fa-circle-check"></i></span>
                    <span [hidden]="chkAbaPadrao.pend_cte"><i class="fa-regular fa-circle"></i></span>
                  </div>
                </label>
              
                <input type="checkbox" class="btn-check" id="aba_pad_pend_tipo_integ" autocomplete="off" [(ngModel)]="chkAbaPadrao.pend_tipo_integ" (click)="selecionaAbaPadrao('pend_tipo_integ')">
                <label class="btn-chk btn-outline-secondary d-flex justify-content-between border-top-0 rounded-0 rounded-bottom" for="aba_pad_pend_tipo_integ">
                  <div>Pendências Tipo Integ</div>
                  <div>
                    <span [hidden]="!chkAbaPadrao.pend_tipo_integ"><i class="fa-solid fa-circle-check"></i></span>
                    <span [hidden]="chkAbaPadrao.pend_tipo_integ"><i class="fa-regular fa-circle"></i></span>
                  </div>
                </label>
              </div>
            </div>
          </div>
        </fieldset>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary"  data-bs-dismiss="modal" (click)="salvarConfig()">Salvar</button>
      </div>
    </div>
  </div>
</div>
